import { Button } from "@justhome/react-ui";
import { FC, PropsWithChildren } from "react";

const Submit: FC<PropsWithChildren> = ({ children }) => {
  return (
    <Button
      iconEnd="Right"
      variant="primary"
      type="submit"
      size="md"
      className="w-fit"
      data-testid="test-submit"
    >
      {children}
    </Button>
  );
};

export default Submit;
